module.exports = __webpack_public_path__ + "img/31.8e9afde9.jpg";